import { render } from "./Supplier.vue?vue&type=template&id=0ffbac95&ts=true"
import script from "./Supplier.vue?vue&type=script&lang=ts"
export * from "./Supplier.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__